// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-ul-container[data-v-2fb72564]{padding:32px 20px}@media screen and (max-width:985px){.filter-ul-container[data-v-2fb72564]{padding:18px 20px 16px}}.filter-ul[data-v-2fb72564]{grid-gap:20px;grid-row-gap:32px;display:grid;grid-auto-flow:column;grid-template-columns:1fr 1fr;grid-template-rows:repeat(8,1fr);row-gap:32px}@media screen and (max-width:985px){.filter-ul[data-v-2fb72564]{grid-gap:10px;row-gap:18px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
